import {
  CircleExclamationSolidIcon,
  DhisLogo,
  SpinnerThridIcon,
} from "@elixir/icons";
import { ABHA_STATUS, Abha, SUBJECT_KEYS } from "@elixir/types";
import { getAclViewClassName } from "@elixir/utils";
import { AddNewAptFieldLayoutUi } from "ui";

const NewAbhaStatusPatient = ({
  abha,
  onClick,
}: {
  abha?: Abha;
  onClick: () => void;
}) => {
  const isDisabled =
    !abha?.id ||
    abha?.status === ABHA_STATUS.PENDING ||
    abha.status === ABHA_STATUS.FAILED;
  return (
    <div className={getAclViewClassName(SUBJECT_KEYS.ABHA)}>
      <AddNewAptFieldLayoutUi
        Icon={<DhisLogo className="-dr-ml-6 dr-min-w-24 dr-h-24" />}
        title="Abha"
      >
        <div
          onClick={onClick}
          className={`dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-min-h-40 dr-h-40 dr-border dr-border-darwin-neutral-200 dr-rounded-8 dr-w-full dr-px-11  ${isDisabled
              ? "dr-cursor-not-allowed dr-text-darwin-neutral-600 dr-bg-darwin-neutral-100"
              : "dr-cursor-pointer dr-text-darwin-primary-primary dr-bg-darwin-neutral-0"
            }`}
        >
          {isDisabled ? (
            (abha?.status === ABHA_STATUS.PENDING ||
              abha?.status === ABHA_STATUS.FAILED) &&
              abha.id ? (
              <div>{abha.id}</div>
            ) : (
              <div>Select patient to add ABHA</div>
            )
          ) : (
            <div>{abha.id}</div>
          )}
        </div>
      </AddNewAptFieldLayoutUi>
      {abha?.status === ABHA_STATUS.PENDING ? (
        <div className="dr-ml-96  dr-flex dr-items-center dr-space-x-8 -dr-mt-4">
          <SpinnerThridIcon
            secondaryClassname="dr-text-darwin-touch-primary-bg-dark"
            primaryClassName="dr-text-darwin-touch-primary-primary"
            className="dr-w-16 dr-h-16 dr-self-start dr-mt-1"
          />
          <div className="dr-text-darwin-touch-neutral-1000 FootnoteRegular">
            Creating patient ABHA...
          </div>
        </div>
      ) : (
        <></>
      )}
      {abha?.status === ABHA_STATUS.FAILED ? (
        <div className="dr-ml-96 dr-text-darwin-touch-red-primary dr-flex dr-items-center dr-space-x-8 -dr-mt-4">
          <CircleExclamationSolidIcon className="dr-w-16 dr-h-16 dr-self-start dr-mt-1" />
          <div className="dr-text-darwin-touch-neutral-1000 FootnoteRegular">
            Abha creation failed. Please try again.
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* {state === ABHA_STATE.ABHA_SERVER_SLOW ? (
        <div className="dr-ml-96 dr-text-darwin-touch-yellow-primary dr-flex dr-items-center dr-space-x-8 -dr-mt-4">
          <CircleExclamationSolidIcon className="dr-w-16 dr-h-16 dr-self-start dr-mt-1" />
          <div className="dr-text-darwin-touch-yellow-dark FootnoteRegular">
            ABHA Servers are running slow. ABHA creation may be affected.
          </div>
        </div>
      ) : (
        <></>
      )} */}
    </div>
  );
};

export default NewAbhaStatusPatient;
